export const romNums = [
    '',
    'I',
    'II',
    'III',
    'IV',
    'V'
];
